import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CategoryFilterContextType {
  selectedCategoryFilter: string | null;
  setSelectedCategoryFilter: (category: string | null) => void;
  clearCategoryFilter: () => void;
}

const CategoryFilterContext = createContext<CategoryFilterContextType | undefined>(undefined);

export const CategoryFilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState<string | null>(null);

  const clearCategoryFilter = () => {
    setSelectedCategoryFilter(null);
  };

  return (
    <CategoryFilterContext.Provider value={{
      selectedCategoryFilter,
      setSelectedCategoryFilter,
      clearCategoryFilter
    }}>
      {children}
    </CategoryFilterContext.Provider>
  );
};

export const useCategoryFilter = () => {
  const context = useContext(CategoryFilterContext);
  if (context === undefined) {
    throw new Error('useCategoryFilter must be used within a CategoryFilterProvider');
  }
  return context;
};